module.exports = __webpack_public_path__ + "img/MyPCP-Health-Education-Logo.03ead72c.svg";